enum ActionTypes {
  SET_APP_ERROR = 'nextiq/App/SET_APP_ERROR',
  SET_GLOBAL_LOADING = 'nextiq/App/SET_GLOBAL_LOADING',
  CONTACT_US = 'nextiq/App/CONTACT_US',
  CONTACT_US_SUCCESS = 'nextiq/App/CONTACT_US_SUCCESS',
  CONTACT_US_FAILURE = 'nextiq/App/CONTACT_US_FAILURE',
}

export default ActionTypes;